var address = {};
module['exports'] = address;
address.county = require("./county");
address.uk_country = require("./uk_country");
address.default_country = require("./default_country");
address.postcode = require("./postcode");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/address/index.js
// module id = 1103
// module chunks = 0